import { Avatar } from "primereact/avatar";
import { MegaMenu } from "primereact/megamenu";
import { useEffect, useRef, useState } from "react";
import "./index.css";
import { useAuthStore } from "presentation/stores/use-auth-store";
import { useNavigate } from "react-router-dom";
import { clearLocalStorage } from "presentation/utils/localStorage";
import { httpClient } from "infra/axios/axios-api";

const MenuProfile = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { clearAuth, userName, userEmployee } = useAuthStore();
  const navigate = useNavigate();

  const items = [
    // {
    //   label: "Meu Perfil",
    //   icon: "pi pi-user",
    //   command: () => {
    //     // Lógica para ir para a página de perfil
    //   },
    // },
    // {
    //   label: "Configurações",
    //   icon: "pi pi-cog",
    //   command: () => {
    //     // Lógica para ir para a página de configurações
    //   },
    // },
    {
      label: "Sair",
      icon: "pi pi-power-off",
      command: () => {
        clearAuth();
        clearLocalStorage();
        navigate("/login");
      },
    },
  ];

  const [photoUrl, setPhotoUrl] = useState<string>("");

  useEffect(() => {
    const fetchPhoto = async () => {
      const currentUrl = await useAuthStore.getState().getPhotoUrl();
      if (currentUrl && currentUrl !== photoUrl) {
        try {
          const response = await httpClient.get(
            `/assets/${currentUrl}`
          );
          setPhotoUrl(response.data.url);
        } catch (error) {
          console.error("Erro ao buscar imagem do funcionário:", error);
        }
      }
    };

    if (!photoUrl) {
      fetchPhoto();
    }
  }, [photoUrl]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuRef]);

  return (
    <div className="profile-group">
      <div className="profile-photo" onClick={toggleMenu}>
        <Avatar image={photoUrl || ""} className={"profile-avatar"} />
        <div className="profile-text">
          <span className="profile-name">{userName}</span>
          <span className="profile-function">
            {userEmployee?.jobTitle.name}
          </span>
        </div>
      </div>

      {isMenuOpen && (
        <div ref={menuRef} style={{ position: "absolute", zIndex: 1000 }}>
          <MegaMenu model={items} />
        </div>
      )}
    </div>
  );
};

export default MenuProfile;
